export const DRAGGABLE_Y_SCROLL_SELECTOR = "[data-draggable-y-scroll]";
export const TIMELINE_FULL_HEIGHT_ATTRIBUTE = "data-timeline-full-height";
export const TIMELINE_PROGRESS_FILL_SELECTOR = "[data-timeline-progress-fill]";
export const TIMELINE_PROGRESS_TRACK_SELECTOR =
  "[data-timeline-progress-track]";
export const TIMELINE_STEP_MARKER_SELECTOR = "[data-timeline-step-marker]";
export const PRIMARY_MOUSE_BUTTON = 0;
export const DRAG_THRESHOLD_PX = 4;
export const FINE_POINTER_MEDIA_QUERY = "(pointer: fine)";
export const DESKTOP_MEDIA_QUERY = "(min-width: 768px)";
export const REDUCED_MOTION_MEDIA_QUERY = "(prefers-reduced-motion: reduce)";
export const AUTO_SCROLL_IDLE_DELAY_MS = 5000;
export const AUTO_SCROLL_SPEED_PX_PER_SECOND = 28;
export const AUTO_SCROLL_DIRECTION_FORWARD = 1;
export const SCROLL_PROGRESS_MIN = 0;
export const SCROLL_PROGRESS_MAX = 1;
export const MOBILE_SCROLL_PROGRESS_VIEWPORT_WEIGHT = 0.85;

export const defaultConfig = {
  idleDelayMs: AUTO_SCROLL_IDLE_DELAY_MS,
  speedPxPerSecond: AUTO_SCROLL_SPEED_PX_PER_SECOND,
};

export const elementEventListenerOptions = {
  wheel: { passive: true },
  touchstart: { passive: true },
};
